
import { useState, useCallback } from 'react';
import { SearchState, SearchResults } from './types/useUnifiedSearchTypes';

export function useSearchState() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<SearchResults>({ items: [], total: 0 });
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [hasSearchCompleted, setHasSearchCompleted] = useState(false);

  const clearAll = useCallback(() => {
    setQuery('');
    setResults({ items: [], total: 0 });
    setError(null);
    setIsLoading(false);
    setIsOpen(false);
    setSelectedIndex(-1);
    setHasSearchCompleted(false);
  }, []);

  const resetResults = useCallback(() => {
    setResults({ items: [], total: 0 });
    setError(null);
    setIsLoading(false);
    setHasSearchCompleted(false);
  }, []);

  return {
    query,
    setQuery,
    results,
    setResults,
    isOpen,
    setIsOpen,
    isLoading,
    setIsLoading,
    error,
    setError,
    selectedIndex,
    setSelectedIndex,
    hasSearchCompleted,
    setHasSearchCompleted,
    clearAll,
    resetResults
  };
}
